import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MailingListProgressSummary } from './types/mailing-list-summary.type';

/**
 * Retrieves a summary of mailing lists progress for a given mailing ID.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing for which to fetch the summary.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing
 * an array of {@link MailingListProgressSummary} objects.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getMailingListsSummary = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingListProgressSummary[]>>(
        formatString(Uri.mailing.getMailingListsSummary, mailingId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
